// extracted by mini-css-extract-plugin
export default {"zoomModal":"M0-z","image":"N0-z","button":"O0-z","isOverlayShown":"P0-z"};